export default __webpack_public_path__ + "static/media/walmart.81e1e0c3.svg";